<template>
  <div style="min-height: 100px;" :data-language="language" v-loading="isLoading">

    <div class="empty" v-if="!isLoading && !messages.length">
      {{ $t('accountSettingsNoOutboxActivity') }}
    </div>

    <expander v-for="item in messages" :key="item.id">

      <span slot="headline">
        <el-row type="flex" align="middle">
          <el-col>
            <span class="activity__contact truncate">{{item.recipientName || item.recipientEmail}}</span>
          </el-col>
          <el-col class="hidden-xs-only">
            <span class="activity__date label truncate">{{moment(item.dateCreated).fromNow()}}</span>
          </el-col>
          <el-col class="text-align-right">
            <span class="indicator__view"
              :class="{
                'is-active': item.isSeen,
                'el-icon-custom-eye': item.isSeen,
                'el-icon-custom-eye-x': !item.isSeen,
              }"></span>
          </el-col>
        </el-row>
      </span>

      <div class="activity__sub-header">
        <ul class="activity__list">
          <li class="activity__list-item">
            {{moment(item.dateCreated).format(dateFormat)}}
          </li>
          <li class="activity__list-item">
            {{item.recipientEmail}}
          </li>
        </ul>
      </div>

      <expander v-for="(attachment, productId) in item.mediaByProduct" :key="productId">

        <span slot="headline">
          <el-row type="flex" align="middle">
            <el-col :span="20">
              <span class="attachment__title">{{attachment.product.title}}</span>
            </el-col>
            <el-col :span="4" class="text-align-right">
              <span class="indicator__view"
                :class="{
                  'is-active': attachment.isSeen,
                  'el-icon-custom-eye': attachment.isSeen,
                  'el-icon-custom-eye-x': !attachment.isSeen,
                }"></span>
            </el-col>
          </el-row>
        </span>

        <ul class="attachment__list">
          <li class="attachment__list-item" v-for="subItem in attachment.media" :key="subItem.id">
            {{subItem.title}}
            <span class="indicator__view"
              :class="{
                'is-active': subItem.isSeen,
                'el-icon-custom-eye': subItem.isSeen,
                'el-icon-custom-eye-x': !subItem.isSeen,
              }"></span>
          </li>
        </ul>

      </expander>

    </expander>

    <el-button @click="loadMediaPage" v-if="!isLoading && hasNextPage">{{$t('nextPageButton')}}</el-button>

  </div>
</template>

<script>
  import constants from '@/constants.json';
  import moment from 'moment';
  import products from '@/components/products';
  import activity from '.';
  import i18n from '@/configured/vue-i18n';
  import Expander from '../Expander.vue';
  import get from 'lodash.get';
  import log from '@/configured/logger';
  import { mapActions, mapGetters, mapState } from 'vuex';

  export default {
    name: 'UserActivityLogOutbox',
    data() {
      return {
        dateFormat: constants.DATE_FORMAT
      }
    },
    computed: {
      ...mapState(activity.store.namespace, [
        'activityMediaUrl',
        'activityMediaData'
      ]),
      ...mapState(i18n.store.namespace, [
        'language' // Todo: make this automatic. Using this in the templates triggers re-rendering moment localization on language change.
      ]),
      ...mapGetters(products.store.namespace, [
        'findProductsUsingAssetId'
      ]),
      messages,
      hasNextPage() {return !!this.activityMediaUrl},
      hasMessages() {return get(this, 'activityMediaData', []).length > 0},
      isLoading() {return this.hasNextPage && !this.hasMessages},
    },
    components: {
      Expander
    },
    methods: {
      ...mapActions(activity.store.namespace, [
        'loadMediaPage'
      ]),
      relativeDate(date) { return !!date ? moment(date).fromNow() : ''; },
      isSeen,
      moment,
    }
  }

  //////////
  function messages() {
    const list = get(this, 'activityMediaData', []);

    const messages = list.filter(msg => msg !== null).map(msg => {
      log.info('preparing message', msg);
      const mediaByProduct = {};
      let hasSeenAnyMedia = false;

      msg.mediaAttachments.filter(attachment => !!attachment.product)
        .forEach(attachment => {
          const product = attachment.product[0];
          if (!mediaByProduct[product.id]) {
            mediaByProduct[product.id] = {
              product: product,
              media: attachment.media
            };
            mediaByProduct[product.id].media.forEach(media => {
              const seen = isSeen(media);
              media.isSeen = seen;
              if(seen) {
                hasSeenAnyMedia = true;
              }
            });
          }
        });

      Object.keys(mediaByProduct).forEach((productId, index)=>{
        let productMediaObject = mediaByProduct[productId];
        productMediaObject.isSeen = productMediaObject.media.some(mediaItem => mediaItem.isSeen);
      });

      msg.isSeen = isSeen(msg) || hasSeenAnyMedia;
      msg.mediaByProduct = mediaByProduct;
      return msg;
    });

    messages.sort(function(a, b){
        var dateA=new Date(a.dateCreated), dateB=new Date(b.dateCreated);
        return dateB-dateA; //sort by date newest first
    })

    log.info('Created messages', messages);
    return messages;
  }

  function isSeen(item) {
    return parseInt(item.totalViews) > 0;
  }
</script>

<style lang="scss" scoped>
  .empty {
    text-transform: uppercase;
    margin-top: 10px;
    text-align: center;
  }

  .indicator__view {
    color: #aaaaaa;

    &.is-active {
      color: #56CB2B;
    }
  }

  .activity {

    &__sub-header {
      margin-bottom: 16px;
    }

    &__list {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &__list-item {}
  }

  .attachment {

    &__list {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &__list-item {

      span {
        margin-left: 8px;
      }
    }
  }

</style>
